/* eslint-disable @typescript-eslint/naming-convention */
import { WheelInput } from 'src/api';

export const wheelRadiusConfig: WheelInput = {
  config_type: WheelInput.config_type.WHEEL,
};
